define('routers/routes',[
    'views/IntroView',
    'views/ContactView',
    'views/ProjectsView',
    'views/AboutView',
    'views/InvestorsView',
    'views/CaseStudiesView',
    'views/PressView',
    'views/ProjectView',
    'views/RedhookView',
    'views/DisclaimerView'
], function (IntroView, ContactView, ProjectsView, AboutView, InvestorsView, CaseStudiesView, PressView, ProjectView, RedhookView, DisclaimerView) {

    "use strict";

    return {
        // ''                      : IntroView,
        contact                 : ContactView,
        projects                : ProjectsView,
        about                   : AboutView,
        investors               : InvestorsView,
        'case-studies'          : CaseStudiesView,
        press                   : PressView,
        'projects/red-hook'     : RedhookView,
        'projects/:slug'        : ProjectView,
        'case-studies/:slug'    : ProjectView,
        'disclaimer'            : DisclaimerView,
        // default path
        '*path'                 : 'notFound'

    };

});
